import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-help-centre',
  templateUrl: './help-centre.component.html',
  styleUrls: ['./help-centre.component.scss']
})
export class HelpCentreComponent implements OnInit, AfterViewInit {
  displayAdmin: boolean = false;
  menuitems: MenuItem[];

  constructor(public authService: AuthService) { }

  ngOnInit() {
    this.authService.isAdmin(this.authService.afAuth.auth.currentUser.uid);
    this.adminContent();
  }

  ngAfterViewInit(){
    this.menuitems = [
        {label: 'Status: Online', icon: 'pi pi-fw pi-plus'},
        {label: 'Help Centre', icon: 'pi pi-fw pi-download', routerLink: ['/help-centre']},
        {label: 'Logout', icon: 'pi pi-fw pi-refresh', command: () => this.authService.SignOut()}
    ]
    }

  adminContent(){
    if(this.authService.adminContent == true){
      this.displayAdmin = true;
    }else{
      this.displayAdmin = false;
    }
  }
}
